export default __webpack_public_path__ + "static/media/Img117.e902c72e.jpg";